import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_BEGIN,
  COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_SUCCESS,
  COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_FAILURE,
  COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function createCollectionConstraint(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_BEGIN,
    });
    const { projectId, version, collectionUuid } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/constraints/${collectionUuid}/collection`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_SUCCESS,
              data: res.data,
              collectionUuid,
            });
            Mixpanel.track('Created collection constraint');
            toast.success('Constraint Created Successfully !');
            resolve(res.data);
          } else {
            dispatch({
              type: COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to create collection constraint');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to create collection constraint');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateCollectionConstraintError() {
  return {
    type: COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_BEGIN:
      return {
        ...state,
        createCollectionConstraintPending: true,
        createCollectionConstraintError: null,
      };

    case COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index] = action.data;
      return {
        ...state,
        createCollectionConstraintPending: false,
        createCollectionConstraintError: null,
        projectCollections,
        selectedCollection: action.data,
      };

    case COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_FAILURE:
      return {
        ...state,
        createCollectionConstraintPending: false,
        createCollectionConstraintError: action.data.error,
      };

    case COLLECTIONS_CREATE_COLLECTION_CONSTRAINT_DISMISS_ERROR:
      return {
        ...state,
        createCollectionConstraintError: null,
      };

    default:
      return state;
  }
}
